import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
const fetchNowMinting = () => commonApiFetch<NFTWithMemesExtendedData>({
  endpoint: "memes_latest"
});
export const useNowMinting = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: [QueryKey.MEMES_LATEST],
      queryFn: fetchNowMinting
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    isFetching,
    error
  } = useQuery(t0);
  let t1;
  if ($[1] !== data || $[2] !== error || $[3] !== isFetching) {
    t1 = {
      nft: data,
      isFetching,
      error
    };
    $[1] = data;
    $[2] = error;
    $[3] = isFetching;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};